export default "__VITE_ASSET__c7679e65__"